import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/custom-terms/{customTermsId}/custom-terms-variables';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['GET'];
type Input = THIS_API['params'] & THIS_API['query'];
type Output = THIS_API['response'];

const getCustomTermsVariables = async ({ customTermsId, page, perPage }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>(PATH_TEMPLATE, { customTermsId });
  const response = await noodleApiClient.get(path, { params: { page, perPage } });
  return response.data;
};

export default getCustomTermsVariables;
